import { IState } from "store/index";

export const isDesktopSelector = (state: IState) => state.app.layout.isDesktop;
export const isExpandedSelector = (state: IState) =>
  state.app.layout.isExpanded;
export const isMobileOpenedSelector = (state: IState) =>
  state.app.layout.isMobileOpened;
export const isLoadingSelector = (state: IState) => state.app.layout.isLoading;
